import React from "react";
import { makeStyles } from "@material-ui/core";
import styles from "../styles/global-styles";
import AccesoryDetail from "../components/core/inventory/product/AccesoryDetail";
import MovileDetail from "../components/core/inventory/product/MovileDetail";
import ChipDetail from "../components/core/inventory/product/ChipDetail";
import CashCardDetail from "../components/core/inventory/product/CashCardDetail";

const useStyles = makeStyles(() => ({
  subtitle: styles.subtitle,
}));

const ContainerProductDetail = ({ location: { state }, history: { push } }) => {
  // const classes = useStyles();
  const {
    brand,
    model,
    barCode,
    productTypeId,
    chipCatalogueId,
    cardCatalogueId,
  } = state || {};

  const returnToDashboard = () => setTimeout(() => push("/dashboard"), 2000);

  if (productTypeId) {
    if ((productTypeId === 1 || productTypeId === 2) && (!brand || !model)) {
      returnToDashboard();
    }
    if (productTypeId === 3 && !chipCatalogueId) {
      returnToDashboard();
    }
    if (productTypeId === 4 && !cardCatalogueId) {
      returnToDashboard();
    }
  } else {
    returnToDashboard();
  }

  /**TODO arreglar validacion 
  const errorInProductsDetail = () => {
    if (!brand || !model || !lote || !productTypeId) {
      return (
        <Typography
          variant="h6"
          component="h4"
          style={{ marginTop: 50 }}
          className={classes.subtitle}
        >
          Error al obtener detalles del producto
        </Typography>
      );
    }
  };
  */

  return (
    <>
      {brand && model && productTypeId === 1 && (
        <MovileDetail brand={brand} model={model} barCode={barCode} />
      )}
      {brand && model && productTypeId === 2 && (
        <AccesoryDetail brand={brand} model={model} barCode={barCode} />
      )}

      {productTypeId === 3 && chipCatalogueId && (
        <ChipDetail chipCatalogueId={chipCatalogueId} />
      )}
      {productTypeId === 4 && cardCatalogueId && (
        <CashCardDetail cardCatalogueId={cardCatalogueId} />
      )}
    </>
  );
};

export default ContainerProductDetail;
